// prevent vue reactivity using Object.freeze in order to reduce memory and unnecessary traversals
export function createFrozenMap (list, keyBy = 'id') {
    const map = {};
    for (const item of list) {
        map[item[keyBy]] = Object.freeze(item);
    }

    return map;
}

// The `kind` field on a given BE entity comes from countables, which are part of versioning
// BE entities (pages, features, etc) that are not versioned do not have an associated `kind`
// value, and need to be augmented to ensure our FE filtering works correctly
export function appendKindIfNotProvided (entity, entityType) {
    if (!entity.kind) entity.kind = entityType;

    return entity;
}
